import { useCallback, useMemo, useRef } from 'react';
import { groupSelectLabelParams } from '../../hooks/useGroupSelectType';

type SelectSearchActionProp = {
  searchParams: (
    groupType: string,
    queryText?: string | null
  ) => groupSelectLabelParams;
  handleSearch: (groupType: string, queryText: string | null) => void;
};

export const useSelectSearchAction = (
  searchHandler: (searchParams: groupSelectLabelParams) => void
): SelectSearchActionProp => {
  const lastSearch = useRef<string | null | undefined>(undefined);
  const searchParams = useCallback(
    (groupType: string, queryText?: string | null): groupSelectLabelParams => {
      return {
        context: groupType,
        query: queryText || undefined
      };
    },
    []
  );
  const handleSearch = useCallback(
    (groupType: string, queryText: string | null) => {
      if (lastSearch.current !== queryText) {
        searchHandler(searchParams(groupType, queryText));
      }
      lastSearch.current = queryText;
    },
    [searchHandler, searchParams]
  );

  return useMemo(
    () => ({
      searchParams,
      handleSearch
    }),
    [handleSearch, searchParams]
  );
};
